module.exports = __webpack_public_path__ + "static/Oracle-plSql-b618a81249866975d2f03148464ebc98.jpg";